import React from 'react';
import { Avatar } from '@mui/material';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

/**
 * A broker group's logo (its `fullLogo`, as the brokerage settings upload it) for the edit
 * drawer's header, or the broker groups icon when it has none or the image won't load.
 */
export const BrokerGroupLogo = ({ fullLogo, name }) => (
	<Avatar
		src={fullLogo}
		alt={name}
		{...(!fullLogo && { variant: 'rounded' })}
		sx={{
			width: 48,
			height: 48,
			backgroundColor: 'transparent',
			color: 'inherit',
			...(fullLogo && { border: 1, borderColor: 'divider' }),
		}}
		slotProps={{ img: { sx: { objectFit: 'contain' } } }}
	>
		<BusinessOutlinedIcon />
	</Avatar>
);
